// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Rf4Kj4v5F_zQfooq-w12t","row":"_14f_MOBu4MTpJnEoljosFM","moreCoursesButton":"_3rc4fo3Pt3_7NjQLsWx6aV","otherButton":"_2N-GBcVeRiNA-6Cf_9FdZG"};